import { IFilterFormItem } from 'common/types';
import {
    userGroupsFilter,
    startDateRangeFilter,
} from 'common/utils/drawerFilters';
import { TReportType } from 'report/types';
import {
    completionDateRangeFilter,
    progressFilter,
    scoreFilter,
    completionStatusFilter,
    scoreThresholdReachedFilter,
    endDateRangeFilter,
    statusFilter,
} from 'report/utils/filter';

const startDateTransKey = 'reportFilters.startDateRange';

export const getReportFilters = (type: TReportType) => {
    switch (type) {
        case 'training':
            return [
                startDateRangeFilter(startDateTransKey),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'course':
            return [
                startDateRangeFilter(startDateTransKey),
                completionDateRangeFilter(),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                completionStatusFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'portfolio':
            return [
                startDateRangeFilter('reportFilters.startDateRangePortfolio'),
                endDateRangeFilter('reportFilters.endDateRange'),
                userGroupsFilter(),
                statusFilter(),
            ] as IFilterFormItem[];
        case 'portfolioTraining':
            return [
                startDateRangeFilter(startDateTransKey),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'portfolioOffer':
            return [
                startDateRangeFilter(startDateTransKey),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'offer':
            return [
                startDateRangeFilter(startDateTransKey),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        // This also takes skill report filters into account
        default:
            return [];
    }
};
